var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.6924C1.00004 16.0026 1.13792 16.2548 1.31543 16.4326V16.4336C1.49328 16.6118 1.74653 16.75 2.05762 16.75C1.74684 16.75 1.51177 16.6504 1.30566 16.4443C1.09956 16.2382 1.00003 16.0032 1 15.6924ZM15.4424 10.8467V13.5H13.9424V10.8467H15.4424ZM10.6924 1.84668V13.5H9.19238V1.84668H10.6924ZM5.94238 6.84668V13.5H4.44238V6.84668H5.94238Z",
    stroke: "#373737",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.f411a272ff4007095a8ca28a94a98eea.svg";
export { ForwardRef as ReactComponent };